<div class="container" *ngIf="!loading">
    <div class="row">
        <div class="col-sm-12">
            <h4>
                Kunden <span *ngIf="type != ''">({{ type }})</span>
            </h4>
        </div>
    </div>
    <div class="row marginBottom2Rem" [formGroup]="filterForm">
        <div class="col-sm-3">
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Suche</mat-label>
                <input type="text" matInput formControlName="searchTerm" placeholder="suchen.."
                    (keydown)="onKeydown($event)" />
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Kundentyp</mat-label>
                <mat-select formControlName="filterByCustomerType" multiple="true">
                    <mat-select-trigger>
                        <span *ngIf="
                this.filterForm.controls.filterByCustomerType.value != null
              ">
                            {{
                            this.filterForm.controls.filterByCustomerType.value
                            | translateFilterCustomer : 'filterByCustomerType'
                            }}
                        </span>
                        <span *ngIf="
                this.filterForm.controls.filterByCustomerType.value?.length > 1
              ">
                            (+{{
                            this.filterForm.controls.filterByCustomerType.value.length - 1
                            }}
                            {{
                            this.filterForm.controls.filterByCustomerType.value?.length ===
                            2
                            ? 'anderer'
                            : 'andere'
                            }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of customerTypes" [value]="sortOption.value">{{
                        sortOption.viewValue }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Portal-Status</mat-label>
                <mat-select formControlName="filterByState" multiple="true">
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByState.value != null">
                            {{
                            this.filterForm.controls.filterByState.value
                            | translateFilterCustomer : 'filterByState'
                            }}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterByState.value?.length > 1">
                            (+{{ this.filterForm.controls.filterByState.value.length - 1 }}
                            {{
                            this.filterForm.controls.filterByState.value?.length === 2
                            ? 'anderer'
                            : 'andere'
                            }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of portalStates" [value]="sortOption.value">{{
                        sortOption.viewValue }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Vertragsstatus</mat-label>
                <mat-select formControlName="filterBySupplyContractState" multiple="true">
                    <mat-select-trigger>
                        <span *ngIf="
                this.filterForm.controls.filterBySupplyContractState.value !=
                null
              ">
                            {{
                            this.filterForm.controls.filterBySupplyContractState.value
                            | translateFilterCustomer : 'filterBySupplyContractState'
                            }}
                        </span>
                        <span *ngIf="
                this.filterForm.controls.filterBySupplyContractState.value
                  ?.length > 1
              ">
                            (+{{
                            this.filterForm.controls.filterBySupplyContractState.value
                            .length - 1
                            }}
                            {{
                            this.filterForm.controls.filterBySupplyContractState.value
                            ?.length === 2
                            ? 'anderer'
                            : 'andere'
                            }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of contractStates" [value]="sortOption.value">{{
                        sortOption.viewValue }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-sm-3" *ngIf="showMoreFilter">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Kartenstatus</mat-label>
                <mat-select formControlName="filterByCardState" multiple="true">
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByCardState.value != null">
                            {{
                            this.filterForm.controls.filterByCardState.value
                            | translateFilterCustomer : 'filterByCardState'
                            }}
                        </span>
                        <span *ngIf="
                this.filterForm.controls.filterByCardState.value?.length > 1
              ">
                            (+{{
                            this.filterForm.controls.filterByCardState.value.length - 1
                            }}
                            {{
                            this.filterForm.controls.filterByCardState.value?.length === 2
                            ? 'anderer'
                            : 'andere'
                            }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of cardStates" [value]="sortOption.value">{{ sortOption.viewValue
                        }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-sm-3" *ngIf="showMoreFilter">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>ERP-Status</mat-label>
                <mat-select formControlName="erpState" multiple="false">
                    <mat-select-trigger>
                        {{ this.filterForm.controls.erpState.value | translateState }}
                    </mat-select-trigger>
                    <!-- (click)="filterCustomers()" -->
                    <mat-option *ngFor="let sortOption of erpStates" [value]="sortOption.value">{{ sortOption.viewValue
                        }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-12">
            <button mat-button mat-raised-button color="accent" (click)="filterCustomers()">
                Anwenden
            </button>

            <button mat-button mat-raised-button color="primary" (click)="showmoreFilters()" style="margin-left: 15px"
                *ngIf="!showMoreFilter">
                Mehr anzeigen
            </button>

            <button mat-button mat-raised-button color="primary" (click)="showLessFilters()" *ngIf="showMoreFilter"
                style="margin-left: 15px">
                Weniger anzeigen
            </button>
            <button mat-button mat-raised-button color="primary" (click)="resetFilter()" style="margin-left: 15px"
                [disabled]="!this.filterForm.touched">
                Filter zurücksetzen
            </button>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12">
            <div class="example-container mat-elevation-z2">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>#</th>
                        <td mat-cell *matCellDef="let element; let i = index" class="mat-column w5">
                            {{ i + 1 }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="user" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>Kunde</th>
                        <td mat-cell *matCellDef="let element">
                            {{ this.customerDisplayName(element) }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="address" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>Anschrift</th>
                        <td mat-cell *matCellDef="let element">
                            <span>
                                {{ element.address?.street }} <br />
                                {{ element.address?.postcode }} {{ element.address?.city }}
                            </span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="contact" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>Kontakt</th>
                        <td mat-cell *matCellDef="let element">
                            <span>
                                <a>{{ element?.email }}</a>
                                <br />
                                <a>{{ element?.phone }}</a>
                            </span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="type" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>Rolle</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-chip-set>
                                <mat-chip color="accent" class="accentChip" selected>{{
                                    element.businessRole | translateState
                                    }}</mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="state" class="mat-column w20">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-chip-set>
                                <mat-chip color="primary" class="primaryChip" selected
                                    *ngIf="element.account.state == 'ACTIVE'">
                                    {{ element.account.state | translateState }}</mat-chip>
                                <mat-chip color="warn" selected *ngIf="element.account.state == 'NEW'">
                                    {{ element.account.state | translateState }}</mat-chip>
                                <mat-chip color="accent" selected *ngIf="element.account.state == 'DISABLE_REQUEST'">
                                    {{ element.account.state | translateState }}</mat-chip>
                                <mat-chip disabled *ngIf="element.account.state == 'DELETED'">{{
                                    element.account.state | translateState
                                    }}</mat-chip>
                                <mat-chip disabled *ngIf="element.account.state == 'REJECTED'">{{ element.account.state
                                    | translateState }}</mat-chip>
                                <mat-chip disabled *ngIf="element.account.state == 'DISABLED'">{{ element.account.state
                                    | translateState }}</mat-chip>
                                <mat-chip disabled *ngIf="element.account.state == 'PENDING'">{{
                                    element.account.state | translateState
                                    }}</mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>Aktion</th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button style="margin: 0 auto !important" [matMenuTriggerFor]="menu"
                                color="accent">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item [disabled]="this.element.account.state != 'PENDING'"
                                    *ngIf="this.isFormFilterActivate">
                                    <span>Freischalten </span>
                                </button>
                                <button mat-menu-item [disabled]="this.element.account.state != 'DISABLE_REQUEST'"
                                    *ngIf="this.isFormFilterDeactivate">
                                    <span>Ablehnen/Sperren</span>
                                </button>
                                <button mat-menu-item [matMenuTriggerFor]="edit">
                                    Bearbeiten
                                </button>
                                <button mat-menu-item [routerLink]="['edit', element.publicId]">
                                    <span>Details</span>
                                </button>
                                <button mat-menu-item [matMenuTriggerFor]="customers">
                                    Status
                                </button>
                                <button mat-menu-item [matMenuTriggerFor]="export">
                                    Export
                                </button>
                                <button mat-menu-item [matMenuTriggerFor]="household"
                                    (mouseenter)="getMembers(element)">
                                    Haushalt
                                </button>
                                <button mat-menu-item *ngIf="usesEnergyContracts"
                                    [routerLink]="[element.publicId, 'contracts']">
                                    Energieverträge
                                </button>
                                <button mat-menu-item *ngIf="usesCustomerCard" [matMenuTriggerFor]="card">
                                    Kundenkarte
                                </button>
                                <button mat-menu-item [routerLink]="['../reservation/plus', element.publicId]">
                                    Vorteilskonto
                                </button>
                                <!-- <button mat-menu-item [routerLink]="['../accountoptions', element.publicId]">Zusatzfunktionen</button> -->
                                <button *ngIf="!hasERPSync" mat-menu-item [routerLink]="['sync', element.publicId]">
                                    Kunde manuell synchronisieren
                                </button>

                                <button *ngIf="hasERPSync" mat-menu-item (click)="syncWithERP(element)">
                                    Kunde mit ERP synchronisieren
                                </button>

                                <button mat-menu-item (click)="deleteUser(element)">
                                    Löschen nach DSGVO
                                </button>
                            </mat-menu>

                            <mat-menu #card="matMenu">
                                <button mat-menu-item [routerLink]="['household', element.publicId]">
                                    <span>Kundenkarten Haushalt</span>
                                </button>
                                <button mat-menu-item [routerLink]="['household', element.publicId]">
                                    Zur Karte
                                </button>
                                <button mat-menu-item (click)="startCardProcess('ASSIGN_CARDS', element.publicId)"
                                    *ngIf="usesCustomerCard">
                                    <span> Karten erstmalig drucken </span>
                                </button>
                                <button mat-menu-item (click)="
                    startCardProcess(
                      'CLOSE_AND_REASSIGN_CARDS',
                      element.publicId
                    )
                  " *ngIf="usesCustomerCard">
                                    <span> Karte erneut produzieren </span>
                                </button>

                                <button mat-menu-item (click)="
                    startCardProcess(
                      'ASSIGN_CARDS_HOUSEHOLDS',
                      element.publicId
                    )
                  " *ngIf="usesCustomerCard">
                                    <span> Karten für den Haushalt produzierenn</span>
                                </button>
                            </mat-menu>

                            <mat-menu #customers="matMenu">
                                <!-- <button mat-menu-item disabled>
                                    <span> Kunde manuell synchronisieren</span>
                                </button> -->
                                <button mat-menu-item (click)="activateUserWithoutNotification(element)">
                                    <span>Freischalten und nicht benachrichtigen</span>
                                </button>
                                <button mat-menu-item (click)="activateUserWithNotification(element)">
                                    <span>Freischalten und benachrichtigen</span>
                                </button>
                                <button mat-menu-item (click)="deactiveUser(element)">
                                    <span> Kunde deaktivieren</span>
                                </button>
                                <!-- <button mat-menu-item (click)="deactivateUserForever(element)">
                                    <span> Ablehnen / Sperren</span>
                                </button> -->

                                <button mat-menu-item [routerLink]="['contact', element.publicId]">
                                    <span>Kontakt aufnehmen</span>
                                </button>
                            </mat-menu>

                            <mat-menu #export="matMenu">
                                <button mat-menu-item (click)="downLoadUserDataAsZIP(element)">
                                    <span>CSV-Export nach DSGVO</span>
                                </button>
                            </mat-menu>

                            <mat-menu #edit="matMenu">
                                <button mat-menu-item [routerLink]="['edit', element.publicId]">
                                    <span>Stammdaten</span>
                                </button>
                                <button mat-menu-item (click)="openResetPassword(element)">
                                    <span>Passwort zurücksetzen</span>
                                </button>
                                <button mat-menu-item [routerLink]="['details', element.publicId]">
                                    Weitere Angaben
                                </button>
                            </mat-menu>

                            <mat-menu #household="matMenu">
                                <button mat-menu-item (click)="addMemberViaDialog(element)"
                                    [disabled]="element.account.state != 'ACTIVE'">
                                    <span> Haushaltsmitglieder hinzufügen</span>
                                </button>

                                <button mat-menu-item [routerLink]="['household-move', element.publicId]"
                                    [disabled]="element.account.state != 'ACTIVE'">
                                    <span> Haushaltsübersicht</span>
                                </button>

                                <button mat-menu-item [routerLink]="['edit', item.publicId]"
                                    *ngFor="let item of element['household']">
                                    <span style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    ">
                                        <span style="margin-right: 8px">
                                            {{ item.person.displayName }}
                                        </span>

                                        <mat-chip-set>
                                            <mat-chip color="primary" class="primaryChip" selected
                                                *ngIf="item.account.state == 'ACTIVE'">
                                                {{ item.account.state | translateState }}</mat-chip>
                                            <mat-chip color="warn" selected *ngIf="item.account.state == 'NEW'">
                                                {{ item.account.state | translateState }}</mat-chip>
                                            <mat-chip color="accent" selected
                                                *ngIf="item.account.state == 'DISABLE_REQUEST'">
                                                {{ item.account.state | translateState }}</mat-chip>
                                            <mat-chip disabled *ngIf="item.account.state == 'DELETED'">{{
                                                item.account.state | translateState }}</mat-chip>
                                            <mat-chip disabled *ngIf="item.account.state == 'REJECTED'">{{
                                                item.account.state | translateState }}</mat-chip>
                                            <mat-chip disabled *ngIf="item.account.state == 'DISABLED'">{{
                                                item.account.state | translateState }}</mat-chip>
                                            <mat-chip disabled *ngIf="item.account.state == 'PENDING'">{{
                                                item.account.state | translateState }}</mat-chip>
                                        </mat-chip-set>
                                    </span>
                                </button>
                            </mat-menu>

                            <!-- <mat-menu #vouchers="matMenu">
                                <button mat-menu-item [routerLink]="['../reservation/plus', element.publicId]">
                                    <span>Vorteilskonto</span>
                                </button>
                            </mat-menu> -->
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"></tr>
                </table>
                <span *ngIf="dataSource?.data.length === 0" class="emptyTableState">Keine passenden Einträge
                    gefunden</span>
                <mat-paginator [length]="page.totalElements" class="paginator-centered" [pageSize]="page.size"
                    [pageIndex]="page.number" (page)="loadPage($event)" [pageSizeOptions]="[12, 24, 36, 48]"
                    [showFirstLastButtons]="true" *ngIf="page">
                </mat-paginator>
            </div>
            <button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['overviewCustomer']"
                [disabled]="usesSSO">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>
</div>

<div class="container" *ngIf="loading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>